<template>
    <counsel-card-row label="분야">
        <v-row class="row--small">
            <v-col cols="6" lg="3">
                <v-select v-model="$data._parent" :items="parents" placeholder="대분류를 선택해주세요" v-bind="selectProps" hide-details @input="$emit('input', null)" />
            </v-col>
            <v-col cols="6" lg="3">
                <v-select
                    v-model="$data._area"
                    :items="children"
                    placeholder="소분류를 선택해주세요"
                    ref="_area"
                    :disabled="!$data._parent"
                    v-bind="selectProps"
                    @input="$emit('input', $data._area)"
                    hide-details
                />
            </v-col>
        </v-row>
    </counsel-card-row>
</template>

<script>
import counselCardRow from "./counsel-card-row.vue";
const selectProps = {
    "item-text": "name",
    "item-value": "_id",
    // placeholder: "분류를 선택해주세요",
    outlined: true,
    dense: true,
    "hide-details": true,
};
export default {
    props: ["value", "parentId"],
    components: { counselCardRow },
    computed: {
        areas() {
            return this.$store.state.areas || [];
        },
        parents() {
            return (this.areas || []).filter(({ _parent }) => !_parent).sort((a, b) => a.order - b.order);
        },
        children() {
            return (this.areas || []).filter(({ _parent, name }) => _parent == this.$data._parent && name !== "기타(입력)").sort((a, b) => a.order - b.order);
        },
    },
    data() {
        return {
            selectProps,
            _parent: this.parentId || null,
            _area: this.value || null,
        };
    },
    watch: {
        value() {
            if (this.value !== this._area) this._area = this.value;
        },
        parentId() {
            if (this.parentId !== this._parent) this._parent = this.parentId;
        },
    },
};
</script>

<style></style>
